import { Controller } from "@hotwired/stimulus"

// The mobile nav panel.
//
// A native <dialog> with showModal(), the same choice _confirm_dialog and
// the food quick-add make, and for the same reason: it takes focus, traps
// it, closes on Escape and paints its own backdrop. A hand-rolled overlay
// has to reimplement all four and usually gets the trap wrong.
//
// NOT menu_controller, which drives the Admin menu. That one makes a
// <details> behave like a menu — it reads element.open and focuses a
// summary — and a <details> has no focus trap, so tabbing past Sign out
// would walk onto the page behind the scrim.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // CLOSE ON THE WAY OUT, or the drawer survives the page under it.
    //
    // Turbo swaps <body> without reloading, and a <dialog> opened with
    // showModal() is in the browser's top layer — so navigating from the
    // drawer left it painted over the new page, and a back gesture landed
    // on Today with the menu still up. Cody, 12 Sep: "if you have nav open
    // and go back (and its to today), the nav stays open and clashes with
    // the page."
    //
    // turbo:before-visit covers a link press; pageshow covers the
    // browser's own history restore, which Turbo does not see.
    this.dismiss = () => this.close()
    document.addEventListener("turbo:before-visit", this.dismiss)
    window.addEventListener("pageshow", this.dismiss)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.dismiss)
    window.removeEventListener("pageshow", this.dismiss)
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // TAPPING THE SCRIM CLOSES IT, which a native <dialog> does not do on its
  // own: ::backdrop is painted by the dialog but is not a separate element,
  // so a click on it targets the <dialog> itself. Everything visible lives
  // in the panel inside, so a click whose target IS the dialog landed on
  // the scrim and nothing else. Cody, 12 Sep: "can't tap out of nav to
  // close."
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
